module.exports = __webpack_public_path__ + "img/Upgrade-your-package-en.423fea1.png";